import { RootState } from '../../../../init-store';
import { isRoomAgentMode, selectIsDisableSharingOverDc } from '../config/selectors';
import { getGoloomSessionFlags, getIsSoundProcessingDisabled } from '../flags/selectors';
import {
    selectBandwidthEffective4kCodec,
    selectIsNoiseCancellationEnabled,
    selectNoiseCancellationType,
    selectVideoProcessorOptions,
} from '../settings';
import { getNoiseCancellationValueByType, getSoundProcessingOptions } from './helpers';

export const selectInitSessionConfig = (state: RootState) => {
    const sessionFlags = getGoloomSessionFlags(state);
    const isSoundProcessingDisabled = getIsSoundProcessingDisabled(state);
    const soundProcessingOptions = getSoundProcessingOptions(isSoundProcessingDisabled);
    const videoProcessorOptions = selectVideoProcessorOptions(state);

    const isNoiseCancellationEnabled = selectIsNoiseCancellationEnabled(state);
    const noiseCancellationType = selectNoiseCancellationType(state);

    if (isNoiseCancellationEnabled && noiseCancellationType) {
        soundProcessingOptions.noiseCancellation = getNoiseCancellationValueByType(noiseCancellationType);
    }

    const isTranscoder = isRoomAgentMode(state);
    const sharingOverDc = selectIsDisableSharingOverDc(state) ? false : undefined;
    const bandwidthEffective4kCodec = selectBandwidthEffective4kCodec(state);
    const flags = {
        isTranscoder,
        sharingOverDc,
        bandwidthEffective4kCodec,
        ...sessionFlags,
    };

    return {
        flags,
        soundProcessing: soundProcessingOptions,
        videoProcessing: videoProcessorOptions,
    };
};
